export const SITE_NAME = "TravelAI Deals";

export const DEFAULT_TITLE = "TravelAI Deals – Oferte inteligente de călătorie cu AI";
export const DEFAULT_DESCRIPTION =
  "Descoperă oferte de zboruri, hoteluri și experiențe cu ajutorul AI. Caută, compară și primește recomandări personalizate.";

export const DEFAULT_OG_IMAGE = "/assets/hero/paris.jpg";

export const DEFAULT_LOCALE = "ro_RO";
export const DEFAULT_LANG = "ro";

